import React, { Fragment, useEffect, useState } from "react";
import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { compose } from "recompose";
import withStyles from "@material-ui/core/styles/withStyles";
import SearchBar from "./SearchBar";
import {
  searchSubscribers,
  setSubscriberSearchTerm,
} from "../../../redux/actions";
import CompositeLabelPaper from "../../../components/CompositeLabelPaper";
import {
  searchSubscribersSelector,
  subscriberSearchTermSelector,
} from "../../../redux/selectors";
import { getUser } from "../../../utilities/userUtilities";
import SubscriberTable from "./SubscriberTable";
import ExportSubscribersButton from "./ExportSubscribersButton";

const styles = {
  root: {
    background: "black",
  },
  input: {
    color: "white",
    backgroundColor: "rgb(36,48,65)",
  },
  gradient: {
    background:
      "linear-gradient(45deg,  #d4e1f7 0%,#d4e1f7 50%,#ffffff 50%,#ffffff 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */",
    filter:
      "progid:DXImageTransform.Microsoft.gradient( startColorstr='#d4e1f7', endColorstr='#ffffff',GradientType=1 ); /* IE6-9 fallback on horizontal gradient */",
  },
};

const Subscribers = ({
  intl,
  subscribers,
  getSubscribers,
  subscriberFilter,
  setSearch,
}) => {
  const [user] = useState(getUser());

  useEffect(() => {
    if (subscribers?.length == 0) {
      getSubscribers(subscriberFilter);
    }
  }, []);

  return (
    <div className="admin-fullheight-wrapper">
      <Fragment>
        <Grid
          container
          justify="space-between"
          alignItems="center"
          style={{ paddingBottom: "32px" }}
        >
          <Grid item>
            <Typography variant="h1" id="headerText">
              {intl.formatMessage({ id: "app.subscribers.pageHeader" })}
            </Typography>
          </Grid>
          <Grid item>
            <ExportSubscribersButton />
          </Grid>
        </Grid>
        <Grid
          container
          justify="space-between"
          style={{ paddingBottom: "50px" }}
        >
          <Grid item style={{ flex: 1 }}>
            <SearchBar onSearchChange={setSearch} />
          </Grid>
        </Grid>
        <CompositeLabelPaper
          label={intl.formatMessage({ id: "app.subscribers.allSubscribers" })}
          Component={SubscriberTable}
          user={user}
          data={subscribers}
          // Filter={Filter}
        />
      </Fragment>
    </div>
  );
};

const mapStateToProps = (state) => ({
  subscribers: searchSubscribersSelector(state),
  subscriberFilter: subscriberSearchTermSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
  getSubscribers: (filter) => dispatch(searchSubscribers(filter)),
  setSearch: (value) => dispatch(setSubscriberSearchTerm(value)),
});

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  injectIntl,
  withStyles(styles),
);

export default enhance(Subscribers);
